import { render, staticRenderFns } from "./ThirdLayout.vue?vue&type=template&id=33bd4503&scoped=true&"
import script from "./ThirdLayout.vue?vue&type=script&lang=js&"
export * from "./ThirdLayout.vue?vue&type=script&lang=js&"
import style0 from "./ThirdLayout.vue?vue&type=style&index=0&id=33bd4503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd4503",
  null
  
)

export default component.exports